import React, { useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./CreatePassword.module.css";
import logo from "../../../assets/images/logo.png";
import {
  InputField,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { LuEye, LuEyeOff } from "react-icons/lu";
import {
  IoCheckbox,
  IoChevronBackOutline,
  IoSquareOutline,
} from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { TbLockCheck } from "react-icons/tb";
import SubHeadingComponent from "../../../components/SubHeadingComponent/SubHeadingComponent";
const CreatePassword = () => {
  const { state } = useLocation();
  console.log("locationn///////////", state);
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPass, setConfirmPass] = useState("");
  const [confirmPassVisible, setConfirmPassVisible] = useState(false);
  const [isLogout, setIslogout] = useState(false);
  const [isSuccessfulModal, setIsSuccessFulModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const formState = [
    { key: "Password", value: password },
    { key: "Confirm Password", value: confirmPass },
  ];

  const showModal = () => {
    setIsSuccessFulModal(true);
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.rightWidthCont}>
          <div className={styles.backDiv} onClick={() => navigate("/")}>
            <IoChevronBackOutline color="var(--white-color)" />
            <TextComponent
              className={styles.White_text}
              text={"Back to login"}
              cursor={"pointer"}
            />
          </div>
          <div className={styles.textDiv}>
            <SubHeadingComponent
              text={"Create Password"}
              color={"var(--white-color)"}
            />
            <TextComponent
              padding={"0px"}
              className={styles.text}
              text={"Create a new strong password"}
            />
          </div>
          <div className={styles.inputDiv}>
            <InputField
              className={styles.input}
              label={"Password"}
              placeholder={"●●●●●●●●●●"}
              labelClass={styles.White_text}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              rightIcon={
                passwordVisible ? (
                  <LuEye size={20} color={"var(--input-icon)"} />
                ) : (
                  <LuEyeOff size={20} color={"var(--input-icon)"} />
                )
              }
              onRightIconPress={() => setPasswordVisible(!passwordVisible)}
              type={passwordVisible ? "text" : "password"}
            />
            <InputField
              className={styles.input}
              label={"Confirm Password"}
              placeholder={"●●●●●●●●●●"}
              value={confirmPass}
              labelClass={styles.White_text}
              onChange={(e) => setConfirmPass(e.target.value)}
              rightIcon={
                confirmPassVisible ? (
                  <LuEye size={20} color={"var(--input-icon)"} />
                ) : (
                  <LuEyeOff size={20} color={"var(--input-icon)"} />
                )
              }
              onRightIconPress={() =>
                setConfirmPassVisible(!confirmPassVisible)
              }
              type={confirmPassVisible ? "text" : "password"}
            />
          </div>
          <div
            className={styles.logoutCheck}
            onClick={() => setIslogout(!isLogout)}
          >
            {isLogout ? (
              <IoCheckbox color="var(--white-color)" />
            ) : (
              <IoSquareOutline color="var(--white-color)" />
            )}
            <TextComponent
              className={styles.White_text}
              style={{ marginLeft: "5px" }}
              text={"Logout from all devices"}
            />
          </div>
          <div className={styles.btn} onClick={showModal}>
            <SubmitButton
              primary
              title={"Create Passsword"}
              btnContainerClass={styles.btnContainer}
              btnClass={`${styles.btnClass}`}
            />
          </div>
        </div>
      </div>

      <Modal
        open={isSuccessfulModal}
        onCancel={() => navigate("/")}
        
        title={"Password Changed Successfully!"}
        textClass={styles.ModaltextClass}
        fontFamily={"Urbanist-semibold"}
        SingleButtonClass={styles?.SingleButtonClass}
        width={"400px"}
        buttonTitle={"Login to you Account"}
        onBtnPress={() => navigate("/")}
        btnStyle={{ width: "100%" }}
      ></Modal>
    </div>
  );
};

export default CreatePassword;
